import { FormControl as MuiFormControl } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'
import { inputFieldStates, inputLabelStyles, inputValueStyles } from '../inputStates.styles'

export const FormControl = styled(MuiFormControl)<{ iserrored?: string }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  gap: ${theme.spacing.xSmall}px;

  .input-label {
    ${inputLabelStyles}
  }

  .helper-text {
    color: ${theme.colors.inputError};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.medium};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 22px;
  }

  .MuiOutlinedInput-root {
    width: 100%;
    height: 48px;
    padding: 0 ${theme.spacing.small}px;
    ${({ iserrored }) => inputFieldStates(iserrored === 'true')}
  }

  .MuiOutlinedInput-input {
    padding: 0;
    ${inputValueStyles}
  }

  .MuiInputAdornment-root .MuiIconButton-root {
    color: ${theme.colors.devicesSecondaryText};
  }
`
